import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { UnidadAcademica } from '../dominio/unidadacademica';

import { Subject }    from 'rxjs/Subject';
import { Response } from '../dominio/Response';

import { Investigador } from '../dominio/investigador';
import {Observable, Subscribable} from 'rxjs/Observable';

import { forkJoin } from "rxjs/observable/forkJoin";

import { NgProgress } from 'ngx-progressbar';
import {ToastrService} from "ngx-toastr";
@Injectable()
export class InvestigadoresService {
    // Observado
  private investigadores = new Subject<Investigador[]>();
  private investigador = new Subject<Investigador>();

  // Observador
  public investigadores$ = this.investigadores.asObservable();
  public investigador$ = this.investigador.asObservable();

  dataStore: {
    investigadores: Investigador[]
  };

  constructor(private apiService: ApiService, private toastr: ToastrService, public ngProgress: NgProgress) {
    this.dataStore = { investigadores: [] };
   }


    getAll(search) {
        this.ngProgress.start();
        let self = this;
        let searchStr = JSON.stringify(search)

        this.apiService.get('investigadores', { filter: searchStr }).subscribe((resp: Response) => {

            let result = resp.data.map(elem => {
                return this.crearInvestigador(elem);
            });
            self.dataStore.investigadores = result;
            self.investigadores.next(result);
            this.ngProgress.done();
        });
    }

    getInvestigador(id) {
        this.ngProgress.start();
        const self = this;
        this.apiService.get('investigador/' + id).subscribe((resp: Response) => {
            const result = this.crearInvestigador(resp.data);
            this.ngProgress.done();
            self.investigador.next(result);
        });
    }
    crearInvestigador(elem): Investigador {
        const tempInvestigador = new Investigador();
        tempInvestigador.ID_Experto = elem.ID_Experto;
        tempInvestigador.Desarrollo = elem.Desarrollo;
        tempInvestigador.Visible = elem.Visible;
        tempInvestigador.Nombre = elem.Nombre;
        tempInvestigador.Apellido = elem.Apellido;
        tempInvestigador.Palabras_clave = elem.Palabras_clave;
        tempInvestigador.Slug = elem.Slug;
        tempInvestigador.Foto = elem.Foto;
        tempInvestigador.Cuil = elem.Cuil;
        tempInvestigador.Tipo = elem.Tipo;
        tempInvestigador.EMail = elem.EMail;
        const tempUnidadAcademica = new UnidadAcademica(
            elem.UnidadAcademica.ID_UnidadAcademica,
            elem.UnidadAcademica.Nombre,
            elem.UnidadAcademica.Titulo,
            elem.UnidadAcademica.Tipo
        );
        tempInvestigador.UnidadAcademica = tempUnidadAcademica;

        return tempInvestigador;
    }

  desactivarActivar(investigador: Investigador) {

    this.ngProgress.start();
    const formData: FormData = new FormData();
    const tempVisible = !investigador.Visible;
    formData.append('ID_Experto', investigador.ID_Experto.toString());
    formData.append('Slug', investigador.Slug);
    formData.append('Visible', tempVisible.toString());
    formData.append('_method', 'POST');

    return this.apiService.post('update-investigador-visible', formData)
    .subscribe(  (response: Response) => {
        investigador.Visible = !investigador.Visible;
        this.dataStore.investigadores.forEach((_investigador, index) => {
          if (investigador.Slug === _investigador.Slug) {
            this.dataStore.investigadores[index] = investigador;
          }
        });
        this.investigadores.next(Object.assign({}, this.dataStore).investigadores);
        this.toastr.success('Cambio de estado realizado', 'Exito!');
        this.ngProgress.done();
        return true;
      }, error => {
        this.ngProgress.done();
        this.toastr.warning('No se realizo el cambio de estado', 'Error');
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/investigadores.service.ts